import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex p-0 transition-opacity outline-none',
    plusIcon: 'hidden h-3 w-3.5 [&>path]:stroke-white',
    cartIcon: 'block h-7.5 w-7.5 [&>path]:stroke-white'
  },
  variants: {
    isInCart: {
      true: {
        base: 'bg-brand-400',
        plusIcon: 'block',
        cartIcon: 'hidden'
      }
    }
  },
  defaultVariants: {
    isInCart: false
  }
});
